export default __webpack_public_path__ + "static/media/Shreshtha.bafd0129.jpeg";